import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import { TranslateModule } from '@ngx-translate/core';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { PathLocationStrategy, LocationStrategy } from '@angular/common';
import { AuthInterceptor } from './data/http/auth.interceptor';

registerLocaleData(localeEs);

@NgModule({ declarations: [
        AppComponent,
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        TranslateModule.forRoot(),
        AppRoutingModule,
        InlineSVGModule.forRoot()], providers: [
        {
            provide: LocationStrategy, useClass: PathLocationStrategy
        },
        {
            provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true
        },
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule {}
